"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.function.name");

var _sendAddress = require("@/api/cms/sendAddress");

var _AddressCascader = _interopRequireDefault(require("@/views/cms/common/AddressCascader"));

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'SendAddressManagement',
  components: {
    AddressCascader: _AddressCascader.default
  },
  data: function data() {
    return {
      searchLoading: false,
      searchForm: {
        name: '',
        phone: ''
      },
      tableData: [],
      pagination: {
        page: 0,
        pageSize: 10,
        total: 0
      },
      createVisible: false,
      createLoading: false,
      createForm: {
        name: '',
        phone: '',
        address: '',
        detailedAddress: '',
        isDefault: 0
      },
      createRules: {
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请选择所在地区',
          trigger: 'change'
        }],
        detailedAddress: [{
          required: true,
          message: '请输入详细地址',
          trigger: 'blur'
        }]
      },
      editVisible: false,
      editLoading: false,
      editForm: {
        id: null,
        name: '',
        phone: '',
        address: '',
        detailedAddress: '',
        isDefault: 0
      },
      editRules: {
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请选择所在地区',
          trigger: 'change'
        }],
        detailedAddress: [{
          required: true,
          message: '请输入详细地址',
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    'createForm.address': function createFormAddress(val) {
      var spaceIdx = (val || '').indexOf(' ');

      if (spaceIdx > -1) {
        var detail = val.substring(spaceIdx + 1).trim();

        if (detail && !this.createForm.detailedAddress) {
          this.createForm.detailedAddress = detail;
        }
      }
    },
    'editForm.address': function editFormAddress(val) {
      var spaceIdx = (val || '').indexOf(' ');

      if (spaceIdx > -1) {
        var detail = val.substring(spaceIdx + 1).trim();

        if (detail && !this.editForm.detailedAddress) {
          this.editForm.detailedAddress = detail;
        }
      }
    }
  },
  activated: function activated() {
    this.loadData();
  },
  methods: {
    loadData: function loadData() {
      var _this = this;

      this.searchLoading = true;
      var params = {
        page: this.pagination.page,
        size: this.pagination.pageSize
      };

      if (this.searchForm.name) {
        params.name = this.searchForm.name;
      }

      if (this.searchForm.phone) {
        params.phone = this.searchForm.phone;
      }

      (0, _sendAddress.getSendAddressList)(params).then(function (response) {
        if (response.code === 200) {
          _this.tableData = response.data.content || [];
          _this.pagination.total = response.data.totalElements || 0;
        }
      }).finally(function () {
        _this.searchLoading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.pagination.page = 0;
      this.loadData();
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        name: '',
        phone: ''
      };
      this.pagination.page = 0;
      this.loadData();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.page = 0;
      this.loadData();
    },
    handlePageChange: function handlePageChange(page) {
      this.pagination.page = page - 1;
      this.loadData();
    },
    openCreateDialog: function openCreateDialog() {
      this.createForm = {
        name: '',
        phone: '',
        address: '',
        detailedAddress: '',
        isDefault: 0
      };
      this.createVisible = true;
    },
    handleCreate: function handleCreate() {
      var _this2 = this;

      this.$refs.createForm.validate(function (valid) {
        if (!valid) return;
        _this2.createLoading = true;

        var data = _this2.splitAddress(_this2.createForm);

        (0, _sendAddress.addSendAddress)(data).then(function (response) {
          if (response.code === 200) {
            _this2.$message.success('新增成功');

            _this2.createVisible = false;
          } else {
            _this2.$message.error(response.message || '新增失败');
          }

          _this2.loadData();
        }).finally(function () {
          _this2.createLoading = false;
        });
      });
    },
    openEditDialog: function openEditDialog(row) {
      this.editForm = {
        id: row.id,
        name: row.name,
        phone: row.phone,
        address: row.address || '',
        detailedAddress: row.detailedAddress || '',
        isDefault: row.isDefault
      };
      this.editVisible = true;
    },
    handleEdit: function handleEdit() {
      var _this3 = this;

      this.$refs.editForm.validate(function (valid) {
        if (!valid) return;
        _this3.editLoading = true;

        var data = _this3.splitAddress(_this3.editForm);

        (0, _sendAddress.updateSendAddress)(data).then(function (response) {
          if (response.code === 200) {
            _this3.$message.success('修改成功');

            _this3.editVisible = false;

            _this3.loadData();
          } else {
            _this3.$message.error(response.message || '修改失败');
          }
        }).finally(function () {
          _this3.editLoading = false;
        });
      });
    },
    handleDelete: function handleDelete(row) {
      var _this4 = this;

      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u5730\u5740\u300C".concat(row.name, " ").concat(row.phone, "\u300D\u5417\uFF1F"), '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _sendAddress.deleteSendAddress)(row.id).then(function (response) {
          if (response.code === 200) {
            _this4.$message.success('删除成功');

            _this4.loadData();
          } else {
            _this4.$message.error(response.message || '删除失败');
          }
        });
      }).catch(function () {});
    },
    fmtAddress: function fmtAddress(val) {
      if (!val) return '';
      return val.replace(/\//g, ' ');
    },
    splitAddress: function splitAddress(form) {
      var data = _objectSpread({}, form);

      var addr = data.address || '';
      var spaceIdx = addr.indexOf(' ');

      if (spaceIdx > -1) {
        data.address = addr.substring(0, spaceIdx);

        if (!data.detailedAddress) {
          data.detailedAddress = addr.substring(spaceIdx + 1).trim();
        }
      }

      return data;
    }
  }
};
exports.default = _default;